import { renderless, api } from "@opentiny/vue-renderless/dropdown-menu/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import Tooltip from "@opentiny/vue-tooltip";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["visibleArrow", "arrowOffset", "placement", "popperClass", "popperAppendToBody", "checkedStatus", "multiStage", "maxHeight"]),
  emits: ["menu-item-click", "created"],
  components: {
    TinyTooltip: Tooltip
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "tiny-zoom-in-top",
      "duration": 150
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c("ul", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.showPopper,
      expression: "state.showPopper"
    }],
    class: _vm.m("min-w-[theme(spacing.18)] max-w-[theme(spacing.52)] absoulte bg-color-bg-1", {
      "py-1.5": _vm.state.size === "medium"
    }, {
      "py-1.5": _vm.state.size === "small"
    }, {
      "py-0.75": _vm.state.size === "mini"
    }, {
      "overflow-x-hidden scrollbar-size-0": _vm.maxHeight
    }, _vm.multiStage ? "!block  rounded-none" : "rounded sm:my-1 py-1 my-2 shadow-sm sm:shadow-md", _vm.popperClass),
    style: "max-height:" + _vm.maxHeight + "px",
    attrs: {
      "data-tag": "tiny-dropdown-menu"
    }
  }, [_c("tiny-tooltip", {
    ref: "tooltip",
    attrs: {
      "effect": "light",
      "content": _vm.state.label,
      "placement": "top-start",
      "manual": true
    },
    model: {
      value: _vm.state.showContent,
      callback: function callback($$v) {
        _vm.$set(_vm.state, "showContent", $$v);
      },
      expression: "state.showContent"
    }
  }), _vm._t("default", null, {
    "selectedIndex": _vm.state.selectedIndex
  })], 2)]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
